import Manager from "../../src/manager";
import React from "react";

function Mapper(data, status, response, error, component) {
	let output = [];
	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			editable,
		},
		period: {
			alias: "period",
			type: "text",
			editable: false,
		},
		periodMeasunit: {
			alias: "periodMeasunit",
			type: "text",
			editable: false,
		},
		tariff: {
			alias: "tariff",
			type: "text",
			editable,
		},
		teaser: {
			alias: "teaser",
			type: "text",
			editable,
		},
		confirm: {
			alias: "confirm",
			type: "button",
			caption: "Επιβεβαίωση",
			events: {
				onClick: function () {
					//TODO close popup
					window.location.replace("/");
				},
			},
			editable,
		},
	};
}

function clickMeActivate(_this) {
	let manager = _this.props.manager;
	let data = _this.props.data;
	window["modal"].setState({
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		body: (
			<Manager
				key="modalForActivation"
				module="modalForActivation"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const ModalForTerms = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: [{}],
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					let _this = this;
					return (
						<div
							className="lightbox"
							id="terms"
							style={{ display: "block" }}>
							<div className="content">
								<h2 className="termsCosmote">Όροι &amp; Προϋποθέσεις </h2>
								<div
									className="text scroll-content jspScrollable"
									tabIndex="0"
									// style={{ overflow: "hidden", padding: "0px" }}
								>
									<div
										// className="jspContainer"
										style={{
											height: "400px",
											overflowY: "scroll",
										}}>
										<div
											className="jspPane"
											style={{
												padding: "0px 30px 0px 0px",
												top: "0px; left: 0px; width: 688px",
											}}>
											<div className="q">My Internet</div>
											<div className="ans">
												η Telekom δημιούργησε τη νέα υπηρεσία{" "}
												<strong>My Internet</strong> (εφεξής «Υπηρεσία») με
												σκοπό την κατά το δυνατόν αμεσότερη πληροφόρηση του
												συνδρομητή αναφορικά με τη χρήση υπηρεσιών δεδομένων
												μέσω της σύνδεσης του.
											</div>
											<div className="q">Προϋποθέσεις Παροχής Υπηρεσίας</div>
											<div className="ans">
												<p>
													Η Υπηρεσία &nbsp;είναι διαθέσιμη στους
													&nbsp;συνδρομητές Οικιακών/Εταιρικών προγραμμάτων
													Συμβολαίου &amp; Mobile Internet, ΚαρτοΣυμβολαίου,
													Business Mobile Cost Control και Καρτοκινητής
													εξαιρουμένων των προγραμμάτων My Way, Mobile i-Data,
													Mobile Internet Unlimited, Mobile Internet 2OGB,
													Mobile-i, Internet of things. &nbsp;
													<br />
													Η Υπηρεσία &nbsp;παρέχει ενημέρωση για την κατανάλωση
													της ενσωματωμένης χρήσης των δεδομένων του
													προγράμματος και τυχόν πρόσθετων πακέτων δεδομένων,
													καθώς και τη δυνατότητα αγοράς πρόσθετων πακέτων
													δεδομένων, ενώ στους &nbsp;συνδρομητές
													Καρτοσυμβολαίου, Business Mobile Cost Control και
													Καρτοκινητής παρέχεται επίσης &nbsp;ενημέρωση
													&nbsp;για το διαθέσιμο χρηματικό υπόλοιπο των
													προγραμμάτων τους. <br />
													Η Telekom δύναται να τροποποιεί τα προγράμματα στα
													οποία παρέχεται η Υπηρεσία. Η τροποποίηση αυτή θα
													ισχύει με την αλλαγή των παρόντων όρων. &nbsp;Οι
													Συνδρομητές μπορούν να ενημερώνονται για τα
													προγράμματα στα οποία παρέχεται η Υπηρεσία από την
													ιστοσελίδα www.telekom.gr, το δίκτυο πωλήσεων και την
													Εξυπηρέτηση Πελατών Telekom.
													<br />
													Από τις 23/4/2015 για τους συνδρομητές Οικιακών και
													Εταιρικών προγραμμάτων φωνής και Mobile Internet και
													από τις 04/07/2016 για τους συνδρομητές
													Καρτοσυμβολαίου, Business Mobile Cost Control και
													Καρτοκινητής, η Υπηρεσία θα παρέχεται ενεργοποιημένη
													για νέες συνδέσεις με δυνατότητα απενεργοποίησής της
													από τους&nbsp; συνδρομητές. Η δυνατότητα χρήσης της
													Υπηρεσίας παρέχεται μόνο εντός Ελλάδας. <br />
													Οι συνδρομητές Οικιακών και Εταιρικών Προγραμμάτων
													μπορούν να ενεργοποιήσουν/απενεργοποιήσουν την
													Υπηρεσία με αίτημα στην Εξυπηρέτηση Πελατών Telekom,
													στο δίκτυο καταστημάτων Telekom, αλλά και ηλεκτρονικά
													μέσω της ειδικής ιστοσελίδας της Υπηρεσίας, της
													ιστοσελίδας του My Telekom και της εφαρμογής Telekom
													App. Oι συνδρομητές οικιακών προγραμμάτων συμβολαίου,
													ΚαρτοΣυμβολαίου και Καρτοκινητής μπορούν να
													ενεργοποιήσουν την Υπηρεσία με αποστολή δωρεάν SMS με
													το λεκτικό «ΜΙ» στο 1333. Επίσης, οι συνδρομητές
													οικιακών προγραμμάτων συμβολαίου μπορούν να
													ενεργοποιήσουν την Υπηρεσία με κλήση στο 1250,
													οι&nbsp; συνδρομητές ΚαρτοΣυμβολαίου και οι
													συνδρομητές Καρτοκινητής με κλήση στο 1330. <br />
													Οι συνδρομητές Εταιρικών προγραμμάτων συμβολαίου φωνής
													και Mobile Internet μπορούν να επιλέξουν να λαμβάνουν
													την Υπηρεσία σε περιορισμένη μορφή, δηλαδή να
													λαμβάνουν μόνο ενημέρωση για την ενσωματωμένη χρήση
													του Προγράμματος ή/και των τυχόν πρόσθετων πακέτων
													δεδομένων. Σε περίπτωση αιτήματος της αλλαγής της
													μορφής της υπηρεσίας κατά τη διάρκεια του τιμολογιακού
													κύκλου, η νέα μορφή της υπηρεσίας θα ισχύσει με την
													έναρξη&nbsp; του νέου τιμολογιακού κύκλου. <br />
													Σε περίπτωση απενεργοποίησης της Υπηρεσίας, η χρέωση
													μετά την κατανάλωση της ενσωματωμένης χρήσης των
													δεδομένων του Προγράμματός του Συνδρομητή ή τυχόν
													πρόσθετων πακέτων δεδομένων θα γίνεται σύμφωνα με τον
													εκάστοτε τιμοκατάλογο του ΟΤΕ.
												</p>
												<p>
													Στην περίπτωση αλλαγής Οικονομικού Προγράμματος ή
													μεταβίβασης της σύνδεσης η Υπηρεσία θα παραμένει
													ενεργοποιημένη εφόσον παρέχεται στο νέο Οικονομικό
													Πρόγραμμα.{" "}
												</p>
											</div>
											<div className="q">Ιστοσελίδα της Υπηρεσίας</div>
											<div className="ans">
												<p>
													Η πρόσβαση στην Υπηρεσία παρέχεται δωρεάν μέσω της
													ειδικής ιστοσελίδας στη διεύθυνση
													http://myinternet.telekom.gr και παρέχει σε όλους τους
													συνδρομητές (Οικιακών και Εταιρικών προγραμμάτων
													Συμβολαίου, Καρτοσυμβολαίου, Business Mobile Cost
													Control και Καρτοκινητής) που έχουν ενεργοποιημένη την
													Υπηρεσία: <br />
													•Ενημέρωση για το υπόλοιπο της διαθέσιμης χρήσης (ΜΒ).
													Η ενημέρωση παρέχεται συγκεντρωτικά αλλά και αναλυτικά
													για κάθε ενεργή υπηρεσία δεδομένων στη σύνδεση του
													συνδρομητή
													<br />
													•Ενημέρωση για την ημερομηνία ανανέωσης τυχόν
													ενσωματωμένης χρήσης (ΜΒ) στη σύνδεση του
													<br />
													•Δυνατότητα ενεργοποίησης πρόσθετου πακέτου δεδομένων
													όποτε το επιθυμεί ο συνδρομητής, με χρέωση στη σύνδεση
													του, ώστε να συνεχίσει την πλοήγηση στο διαδίκτυο
													<br />
													•Δυνατότητα ενημέρωσης για τις ισχύουσες χρεώσεις και
													τους παρόντες Όρους <br />
													•Δυνατότητα απενεργοποίησης της Υπηρεσίας. Με την
													απενεργοποίηση της Υπηρεσίας η χρέωση για χρήση
													δεδομένων θα γίνεται σύμφωνα με τον εκάστοτε
													τιμοκατάλογο του ΟΤΕ.
													<br />
													•Στους συνδρομητές Οικιακών και Εταιρικών προγραμμάτων
													Συμβολαίου:
													<br />
													•Ενεργοποίηση οποιουδήποτε «Πακέτου Mobile Internet»,
													ή «Πακέτου Mobile Internet Day Pass», εφόσον η σύνδεση
													Telekom που έχει στην κατοχή του ο συνδρομητής δεν
													παρέχει ενσωματωμένη χρήση δεδομένων (ΜΒ)
													<br />
													•Δυνατότητα επιλογής χρέωσης των δεδομένων βάσει
													ογκοχρέωσης μέχρι τη λήξη της τρέχουσας τιμολογιακής
													περιόδου. Σε αυτή την περίπτωση, θα ενημερώνεται με
													γραπτό μήνυμα για κάθε δέκα (10) ευρώ χρέωσης
													δεδομένων με ανώτατο όριο ενημέρωσης τα διακόσια (200)
													ευρώ. Μετά τη συμπλήρωση του άνω ποσού ο συνδρομητής
													μπορεί να συνεχίσει να κάνει χρήση δεδομένων αλλά δεν
													θα λαμβάνει καμία επιπλέον ενημέρωση.
													<br />
													Στους συνδρομητές Καρτοσυμβολαίου, Business Mobile
													Cost Control και Καρτοκινητής: <br />
													•Ενημέρωση για το διαθέσιμο χρηματικό υπόλοιπο <br />
													Ενημέρωση για την ημερομηνία λήξης των πρόσθετων
													πακέτων δεδομένων που έχει ενεργοποιήσει ο συνδρομητής
													<br />
													Για τους συνδρομητές &nbsp;που έχουν ενεργή την
													Υπηρεσία και βρίσκονται στο εξωτερικό, ισχύουν τα
													ακόλουθα:
													<br />
													<br />
													<b>
														Συνδρομητές με ενεργή την Υπηρεσία My Internet και
														την υπηρεσία TRAVEL PASS.{" "}
													</b>
													<br />
													Οι ανωτέρω συνδρομητές μπορούν να καταναλώσουν στο
													εξωτερικό μόνο την ενσωματωμένη χρήση δεδομένων του
													προγράμματος τους και όχι τυχόν ενεργοποιημένα
													πρόσθετα πακέτα ή υπηρεσίες δεδομένων. <br />
													Οι συνδρομητές θα ενημερώνονται μέσω της ιστοσελίδας
													της Υπηρεσίας για το συνολικό υπόλοιπο της διαθέσιμης
													χρήσης τους (ΜΒ) καθώς και αναλυτικά για κάθε ενεργή
													υπηρεσία δεδομένων της σύνδεσής τους. <br />
													<br />
													Μέσω της ιστοσελίδας της Υπηρεσίας οι συνδρομητές θα
													ενημερώνονται: <br />
													<br />
													•Ότι μέσω της υπηρεσίας Travel Pass μπορεί να
													καταναλωθεί{" "}
													<strong>
														μόνο η ενσωματωμένη χρήση του προγράμματος{" "}
													</strong>
													και όχι τα δεδομένα (ΜΒ) από τυχόν ενεργοποιημένα
													πρόσθετα πακέτα Internet. <br />
													•Ότι μέσω &nbsp;του link “Αναλυτικά” μπορούν να
													ενημερωθούν για την κατανάλωση των δεδομένων του
													προγράμματος τους.
													<br />
													•Ότι κατά την κατανάλωση της ενσωματωμένης χρήσης του
													προγράμματός τους θα λάβουν&nbsp; ενημερωτικά μηνύματα
													μετά την κατανάλωση του &nbsp;80% και του &nbsp;100%
													αυτής. <br />
													•Ότι μετά την κατανάλωση της ενσωματωμένης χρήσης του
													προγράμματός τους&nbsp; για την &nbsp;πρόσβαση στο
													Internet θα ισχύουν οι χρεώσεις περιαγωγής της
													υπηρεσίας Travel Pass <br />
													•&nbsp;Ότι θα λαμβάνουν γραπτά μηνύματα για κάθε 10€
													χρέωσης δεδομένων με ανώτατο όριο ενημέρωσης τα
													διακόσια (200) ευρώ. <br />
													Ότι δεν είναι δυνατή η &nbsp;αγορά πρόσθετων πακέτων ή
													υπηρεσιών δεδομένων.
													<br />
													<b>
														{" "}
														Συνδρομητές με ενεργή μόνο την Υπηρεσία My
														Internet.{" "}
													</b>
													<br />
													Οι συνδρομητές θα ενημερώνονται μέσω της ιστοσελίδας
													της Υπηρεσίας, ότι δεν είναι δυνατή η χρήση της όσο
													βρίσκονται σε περιαγωγή. <br />
													Επιπλέον, οι συνδρομητές Οικιακών και Εταιρικών
													προγραμμάτων συμβολαίου Telekom που δεν έχουν
													ενεργοποιήσει την υπηρεσία Travel &amp; Surf, θα
													λαμβάνουν γραπτά μηνύματα για κάθε&nbsp; 10€ χρέωσης
													δεδομένων με ανώτατο όριο ενημέρωσης τα διακόσια (200)
													ευρώ. <br />
												</p>
											</div>
											<div className="q">Χρήση της Υπηρεσίας</div>
											<div className="ans">
												<p>
													Μετά την ενεργοποίηση της Υπηρεσίας και εφόσον έχει
													καταναλωθεί η ενσωματωμένη χρήση δεδομένων (ΜΒ) του
													προγράμματος ή της πρόσθετης υπηρεσίας δεδομένων,
													διακόπτεται αυτόματα η πρόσβαση της σύνδεσης στο
													διαδίκτυο μέχρι το τέλος της τρέχουσας τιμολογιακής
													περιόδου χωρίς περαιτέρω&nbsp; χρέωση του συνδρομητή.
													<br />
													Εφόσον ο συνδρομητής προσπαθήσει να πλοηγηθεί στο
													διαδίκτυο, μέσω του δικτύου Telekom ανακατευθύνεται
													αυτόματα στην ιστοσελίδα της Υπηρεσίας και
													ενημερώνεται ότι έχει καταναλωθεί η δωρεάν
													ενσωματωμένη χρήση του προγράμματός του ή ή/και των
													τυχόν πρόσθετων πακέτων δεδομένων. <br />
													Ο συνδρομητής για να συνεχίσει να έχει πρόσβαση στο
													διαδίκτυο μπορεί να ενεργοποιήσει μια από τις
													διαθέσιμες επιλογές που εμφανίζονται στη σελίδα της
													υπηρεσίας. <br />
													Για τους συνδρομητές Οικιακών και Εταιρικών
													προγραμμάτων συμβολαίου Telekom με την ενεργοποίηση
													της Υπηρεσίας ενεργοποιείται αυτόματα και η
													υπηρεσία&nbsp; COST CONTROL με την οποία ο&nbsp;
													συνδρομητής λαμβάνει δωρεάν ενημερωτικά γραπτά
													μηνύματα (SMS) όταν καταναλώσει&nbsp; το 80% και το
													100% της ενσωματωμένης χρήσης δεδομένων του
													προγράμματος ή της πρόσθετης υπηρεσίας δεδομένων που
													έχει ενεργοποιημένη στη σύνδεση του. Η υπηρεσία COST
													CONTROL παραμένει ενεργοποιημένη και μετά την
													απενεργοποίηση της Υπηρεσίας στους συνδρομητές
													Οικιακών προγραμμάτων φωνής και Mobile Internet, ενώ
													οι συνδρομητές Εταιρικών&nbsp; προγραμμάτων φωνής και
													Mobile Internet θα πρέπει να επιλέξουν τη διατήρηση ή
													απενεργοποίηση της. <br />
													Οι συνδρομητές Καρτοσυμβολαίου, Business Mobile Cost
													Control και Καρτοκινητής ενημερώνονται με γραπτά
													μηνύματα (SMS), όταν έχουν ακόμα διαθέσιμα &nbsp;10 MB
													και στο 100% της ενσωματωμένης χρήσης ή του πρόσθετου
													πακέτου δεδομένων. Επιπλέον ενημερώνονται 1 μέρα πριν
													και στη λήξη τυχόν πρόσθετου πακέτου δεδομένων.
													<br />
													Σε όλα τα μηνύματα περιλαμβάνεται και σύνδεση (link)
													για πρόσβαση στην ειδική ιστοσελίδα της Υπηρεσίας.
												</p>
												<p>
													Η ενημέρωση με γραπτά μηνύματα στο 80% και στο 100%,
													μέσω της υπηρεσίας COST CONTROL, καθώς και &nbsp;όταν
													απομένουν 10 MB και στο 100% της ενσωματωμένης χρήσης
													ή του πρόσθετου πακέτου δεδομένων για τους συνδρομητές
													Καρτοσυμβολαίου, Business Mobile Cost Control και
													Καρτοκινητής ενδέχεται να παρέχεται με μικρή
													καθυστέρηση ανάλογα με την ενημέρωση των συστημάτων
													του OTE. <br />
													Τα ενημερωτικά μηνύματα που αφορούν την κατανάλωση της
													ενσωματωμένης χρήσης ή των πρόσθετων πακέτων δεδομένων
													θα αποστέλλονται όλο το 24ώρο. Διευκρινίζεται ότι σε
													συσκευές τύπου Smart Phone τα ενημερωτικά μηνύματα
													ενδέχεται να σταλούν κατά την ημερομηνία και ώρα της
													αυτόματης σύνδεσης των τυχόν&nbsp;
													εγκατεστημένων&nbsp; εφαρμογών&nbsp; (όπως καιρός,
													νέα, e-mail κ.α.) στις ανωτέρω συσκευές. <br />
													Τα ενημερωτικά μηνύματα που στέλνονται 1 μέρα πριν και
													στη λήξη των πρόσθετων πακέτων για τους συνδρομητές
													Καρτοσυμβολαίου, Business Mobile Cost Control και
													Καρτοκινητής, δεν αποστέλλονται κατά το χρονικό
													διάστημα 23:00 – 07:00.
												</p>
												<p>
													Στη περίπτωση συνδρομητών με πρόγραμμα χωρίς
													ενσωματωμένη χρήση δεδομένων ή ενεργή πρόσθετη
													υπηρεσία δεδομένων, εφόσον ο συνδρομητής προσπαθήσει
													να πλοηγηθεί στο διαδίκτυο, μέσω του δικτύου&nbsp;
													Telekom θα ανακατευθύνεται αυτόματα στην ιστοσελίδα
													της Υπηρεσίας και θα ενημερώνεται ότι δεν έχει
													διαθέσιμα ΜΒ για πρόσβαση στο διαδίκτυο. Ο συνδρομητής
													για να αποκτήσει πρόσβαση στο διαδίκτυο θα πρέπει
													&nbsp;να επιλέξει την ενεργοποίηση πρόσθετου πακέτου
													δεδομένων μέσω της Υπηρεσίας.
													<br />
													Διευκρινίζεται επίσης, ότι εφόσον ο συνδρομητής
													πλοηγείται σε σελίδες με το πρωτόκολλο ασφαλείας https
													ή κάνει χρήση internet applications ή video/audio
													streaming, ο OTE δεν έχει την τεχνική δυνατότητα να
													τον ανακατευθύνει αυτόματα στην ιστοσελίδα της
													Υπηρεσίας μετά την κατανάλωση της ενσωματωμένης χρήσης
													δεδομένων. <br />
													Στην περίπτωση αυτή ωστόσο, μετά την κατανάλωση της
													ενσωματωμένης χρήσης δεδομένων θα γίνεται αυτόματη
													διακοπή της πρόσβασης της σύνδεσής του στο διαδίκτυο
													και ο συνδρομητής θα λαμβάνει γραπτό μήνυμα που
													περιέχει και σύνδεση (link) για πρόσβαση στην ειδική
													ιστοσελίδα της Υπηρεσίας. <br />
													Δείτε στην ιστοσελίδα της Υπηρεσίας στο www.telekom.gr
													αναλυτικές πληροφορίες για τις επιλογές χρήσης
													δεδομένων, που παρέχονται ανά περίπτωση για
													συνδρομητές Οικιακών/Εταιρικών προγραμμάτων Συμβολαίου
													&amp; Mobile Internet, ΚαρτοΣυμβολαίου, Business
													Mobile Cost Control και Καρτοκινητής στην Υπηρεσία.
												</p>

												<p>
													Στις τιμές των πακέτων εφαρμόζεται Τέλος Συνδρομητών
													Κινητής Τηλεφωνίας 10% επί του μηνιαίου λογαριασμού
													κάθε σύνδεσης προ ΦΠΑ και Τέλος Κινητής Τηλεφωνίας
													δέκα τοις εκατό (10%) επί της αξίας του χρηματικού
													υπολοίπου προ Φ.Π.Α.
												</p>
												<p>
													Στα προγράμματα Mobile Internet δεν επιβάλλεται Τέλος
													Συνδρομητών Κινητής Τηλεφωνίας επί του παγίου και της
													χρήσης Internet. Για τα συγκεκριμένα προγράμματα το
													Τέλος Συνδρομητών Κινητής Τηλεφωνίας θα επιβάλλεται
													μόνο στις περιπτώσεις που γίνει χρήση των υπηρεσιών
													SMS, GPRS WAP, DATA/FAX καθώς και υπηρεσιών
													πολυμεσικής πληροφόρησης. Εξαιρούνται τα προγράμματα
													Mobile Internet AnyWay στα οποία επιβάλλεται Τέλος
													Συνδρομητών Κινητής Τηλεφωνίας επί του παγίου και της
													χρήσης Internet.
												</p>
												<p>
													Το Τέλος Συνδρομητών Κινητής και Καρτοκινητής
													Τηλεφωνίας{" "}
													<b>
														είναι μηδενικό (0%) για φυσικά πρόσωπα ηλικίας
														δεκαπέντε (15) έως και είκοσι εννέα (29) ετών,
														δηλαδή πρόσωπα που κατά τη διάρκεια κάθε έτους έχουν
														συμπληρώσει το δέκατο τέταρτο (14ο) έτος της ηλικίας
														τους έως την 31η Δεκεμβρίου του προηγουμένου έτους
														και δεν έχουν συμπληρώσει το τριακοστό (30ο) έτος
														της ηλικίας τους έως την ημερομηνία αυτή.
													</b>
												</p>
												<p>
													Για την εφαρμογή του μηδενικού συντελεστή απαιτείται
													εγγραφή σε ειδική εφαρμογή προσβάσιμη μέσω της ενιαίας
													ψηφιακής πύλης της δημόσιας διοίκησης (gov.gr-ΕΨΠ).
												</p>
												<p>
													Ο μηδενικός συντελεστής εφαρμόζεται για μία (1)
													σύνδεση ή ένα (1) καρτοκινητό ανά δικαιούχο, μετά την
													ολοκλήρωση της εγγραφής στην εφαρμογή των δικαιούχων ή
													των εχόντων την επιμέλειά τους σε περίπτωση ανηλίκων,
													από την πρώτη τιμολόγηση σε περίπτωση σύνδεσης
													συμβολαίου ή από την επόμενη ανανέωση χρηματικού
													υπολοίπου σε περίπτωση σύνδεσης καρτοκινητής.
												</p>
												<p>
													Ο συντελεστής 10% καταλαμβάνει λογαριασμούς που
													εκδίδονται και κάρτες χρόνου ομιλίας ή επικοινωνίας
													και ανανεώσεις που ενεργοποιούνται από τους
													καταναλωτές από την 01/01/2022 και μετά.
												</p>
												<p>
													Ο μηδενικός συντελεστής εφαρμόζεται σε λογαριασμούς
													που εκδίδονται και κάρτες χρηματικού υπολοίπου ή
													επικοινωνίας και ανανεώσεις που ενεργοποιούνται από
													τους καταναλωτές από την 01/01/2022 και μετά, και
													σύμφωνα με όσα αναφέρονται ανωτέρω.
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="clear"></div>
								<div className="clear"></div>
								<a
									className="cancel addCursorPointer"
									onClick={() => {
										window["modal"].setState({ show: false });
										//remove class locked when modal closes
										document.getElementById("body").classList.remove("locked");
										// if (window.location.pathname === "/")
										//   clickMeActivate(_this);
									}}></a>
							</div>
						</div>
					);
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: {
					onClick: function (e) {},
				},
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ModalForTerms;
